// import i18n from 'i18next';
// import { initReactI18next } from 'react-i18next';
// import LanguageDetector from 'i18next-browser-languagedetector';

// // Import the translation files
// import enTranslation from './translate/en-us.json';
// import arTranslation from './translate/ar-om.json';

// // Initialize i18next
// i18n
//   .use(LanguageDetector) // Detect user language
//   .use(initReactI18next) // Pass i18n instance to react-i18next
//   .init({
//     resources: {
//       en: {
//         translation: enTranslation,
//       },
//       ar: {
//         translation: arTranslation,
//       },
//     },
//     lng: 'en', // Default language
//     fallbackLng: 'en', // Fallback language if translation is not available
//     interpolation: {
//       escapeValue: false, // React already does escaping
//     },
//     react: {
//       useSuspense: false,
//     },
//   });

// // Function to toggle language
// const toggleLanguage = () => {
//   const currentLang = i18n.language;
//   const newLang = currentLang === 'en' ? 'ar' : 'en';
//   i18n.changeLanguage(newLang);
//   // Update the document direction
//   document.documentElement.setAttribute('dir', newLang === 'ar' ? 'rtl' : 'ltr');
// };

// // Event listener for Alt+Q
// const handleKeyPress = (e) => {
//   if (e.altKey && e.key.toLowerCase() === 'q') {
//     toggleLanguage();
//   }
// };

// // Add the event listener when the application starts
// window.addEventListener('keydown', handleKeyPress);

// export default i18n;


import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslation from './translate/en-us.json';
import arTranslation from './translate/ar-om.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      ar: { translation: arTranslation },
    },
    lng: 'en', // default
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

document.documentElement.setAttribute(
  'dir',
  i18n.language === 'ar' ? 'rtl' : 'ltr'
);

export default i18n;
